import { useAuth } from '@clerk/nextjs';
import { useEffect, useRef, useState } from 'react';
import { trpc } from '@/code/lib/utils/trpc';

type FullStoryModule = typeof import('@fullstory/browser');

// Lazy-loads @fullstory/browser after hydration to keep it out of the shared bundle.
export function FullstoryProvider() {
  const auth = useAuth();
  const userData = trpc.user.clerkUserData.useQuery(undefined, {
    enabled: !!auth.isSignedIn,
  });
  const [initializedFullStory, setInitializedFullStory] = useState(false);
  const fsRef = useRef<FullStoryModule | null>(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (!process.env.NEXT_PUBLIC_FULLSTORY_ORG_ID) return;

    let cancelled = false;
    import('@fullstory/browser').then((FullStory) => {
      if (cancelled) return;
      try {
        FullStory.init({ orgId: process.env.NEXT_PUBLIC_FULLSTORY_ORG_ID! });
        fsRef.current = FullStory;
        setInitializedFullStory(true);
      } catch (_e) {
        return;
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const FullStory = fsRef.current;
    // user may be null for employees without DB User records
    if (
      userData.data?.user &&
      initializedFullStory &&
      FullStory &&
      FullStory.isInitialized()
    ) {
      FullStory.FullStory('setIdentity', {
        uid: userData.data.user.id,
        properties: {
          displayName: userData.data.displayName,
          email: userData.data.user.primaryEmail ?? '',
        },
      });
    }
  }, [userData.data, initializedFullStory]);

  return <></>;
}
